import React from 'react'
import { navigate } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"
import { getShopifyImage } from "gatsby-source-shopify"

const ColorPanelDynamic = ({data, title, selected, className = '', wrapFirstRow = false, multiSelect = false}) => {

    const safeData = Array.isArray(data) ? data : [];

    if (!Array.isArray(safeData)) {
        //console.error("Expected data to be an array, but got:", typeof data, data);
        return null;
    }

    return (
        <React.Fragment>
            <section className={`my-5`}>
                <div className={`flex ${wrapFirstRow && 'flex-wrap-reverse w-1/2'}  justify-between items-center`}>
                    <div className="flex flex-nowrap gap-x-1">
                        <span className="text-sm font-semibold">COLOR:</span>
                        <span className="text-sm font-normal">{title}</span>
                    </div>
                </div>
                <div className="flex flex-wrap gap-2 mt-3" aria-label='Color Variation container'>
                    {   
                        safeData && safeData?.map((item, index) => {
                            const swatchParts = item?.swatch?.split('&');
                            const name = swatchParts?.[2]?.replace("name-", "");
                            const filename = swatchParts?.[3]?.replace("print-", "").replace("solid-", "");
                            
                            const colorData = {
                                originalSrc: `https://cdn.shopify.com/s/files/1/1219/5720/files/${filename}`,
                                width: 100,
                                height: 100,
                            };

                            const gatsbyColorImage = getShopifyImage({
                                                        image: colorData ?? colorData,
                                                        layout: "constrained",
                                                        crop: "contain",
                                                        width: 28,
                                                        height: 28,
                                                    })
                        
                            return (
                                <div className={`static xl:relative group overflow-hidden xl:overflow-visible cursor-pointer`} onClick={() => navigate(`/products/${swatchParts?.[1]}`)} key={`${swatchParts?.[1]}-${index}`}>
                                    <GatsbyImage
                                         className={`${swatchParts?.[1] === selected ? 'border-2 border-black opacity-100 circle-8' : 'border-1 opacity-50 circle-8'}`}
                                        style={{overflow: "hidden", width: "28px", height: "28px", borderRadius: "50%"}}
                                        objectFit="contain"
                                        loading="lazy"
                                        alt={`${swatchParts?.[1]} ${selected}`}
                                        image={gatsbyColorImage ?? gatsbyColorImage}
                                        aria-label={`changed-variant`}
                                    />

                                    <span className='absolute capitalize left-1/2 transform -translate-x-1/2 bottom-full mb-2 bg-gray-800 text-white text-sm py-1 px-3 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-50 whitespace-nowrap'>
                                        {`${name?.replace("-", " ")}`}
                                    </span>
                                </div>
                            )
                        })
                    }
                </div>
            </section>
        </React.Fragment>
    );
}

export default ColorPanelDynamic;